/**
 * API origin for fetch/axios.
 *
 * In local CRA dev, we return '' so the CRA proxy (setupProxy.js) forwards
 * the Express backend same-origin — session cookies work for localhost
 * and 127.0.0.1. Match `REACT_APP_PROXY_TARGET` in `client/.env` to the API `PORT`.
 *
 * In prod we serve the built client from the same Express server, so '' also
 * works there. Set REACT_APP_API_URL only when the frontend is hosted on a
 * different origin than the API.
 */
export function getApiBase() {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/$/, '');
  }
  return '';
}
